import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const loadScript = src => new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.id = "razorpayScript"
    script.onload = () => {
        console.log('razorpay loaded successfully');
        resolve(true);
    };
    script.onerror = () => {
        console.log('error in loading razorpay');
        resolve(false);
    };
    document.body.appendChild(script);
});
const usertoken = localStorage.getItem("authToken");

function PaymentPage({ orderId, currency, amount}) {
    const paymentId = useRef(null);
    const paymentMethod = useRef(null);
    const userDetails = useSelector((state)=>state?.userSlice?.value)

    const displayRazorpay = async (options) => {
        const res = await loadScript(
            'https://checkout.razorpay.com/v1/checkout.js',
        );
        if (!res) {
            console.log('Razorpay SDK failed to load. Are you online?');
            return;
        }
        const rzp1 = new window.Razorpay(options);
        rzp1.on('payment.submit', (response) => {
            paymentMethod.current = response.method;
        });
        rzp1.on('payment.failed', (response) => {
            paymentId.current = response.error.metadata.payment_id;
        });
        rzp1.open();
    };


    // informing server about payment
    const handlePayment = async (status, orderDetails = {}) => {
        // console.log(orderDetails)
        if (status == 'verifying') {
            fetch(`${process.env.REACT_APP_API_URL}/service/verifyOrder`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${usertoken}`
                },
                method: 'POST',
                body: JSON.stringify(orderDetails)
            }).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data)
                window.location.reload()
                // Show payment complete
                
            }).catch((err) => {
                console.log(err)
                window.location.reload()
            })
        } else {
            // Show Error
        }
    };

    const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount,
        currency,
        name: userDetails?.first_name+" "+userDetails?.last_name,
        order_id: orderId,
        handler: (response) => {
            // console.log(response);
            paymentId.current = response.razorpay_payment_id;
            handlePayment('verifying', {
                orderId,
                paymentId: response.razorpay_payment_id,
                signature: response.razorpay_signature,
            });
        },
        modal: {
            confirm_close: true,
            ondismiss: async (reason) => {
                const {
                    reason: paymentReason, field, step, code,
                } = reason && reason.error ? reason.error : {};
                if (reason === undefined) {
                    console.log('cancelled');
                    handlePayment('Cancelled');
                }
                else if (reason === 'timeout') {
                    handlePayment('timedout');
                }
                else {
                    handlePayment('failed', {
                        paymentReason, field, step, code,
                    });
                }
                window.location.reload()
            },
        },
        retry: {
            enabled: false,
        },
        timeout: 900,
        theme: {
            color: '',
        },
    };

    useEffect(() => {
        displayRazorpay(options);
    }, []);

    return null;
}

export default PaymentPage